/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Pre_Render_Frame_Cache_Progress_StatusInputs */



/**
* | output |
* | --- |
* | "Generating frame cache {current}/{total}" |
*
* @param {Pre_Render_Frame_Cache_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_progress_status = /** @type {((inputs: Pre_Render_Frame_Cache_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Génération du cache d'images ${i?.current}/${i?.total}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Generiere Frame-Cache ${i?.current}/${i?.total}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Generazione della cache dei frame ${i?.current}/${i?.total}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Создание кэша кадров ${i?.current}/${i?.total}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Generando caché de fotogramas ${i?.current}/${i?.total}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`生成帧缓存${i?.current}/${i?.total}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`フレームキャッシュ${i?.current}/${i?.total}を生成しています`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`फ्रेम कैश जनरेट किया जा रहा है ${i?.current}/${i?.total}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Gerando cache de quadros ${i?.current}/${i?.total}`)
	return /** @type {LocalizedString} */ (`Generating frame cache ${i?.current}/${i?.total}`)
});